import firebase from 'firebase/app'

export const fetchGroups = async() => {
  try{
    const  querySnapshot = await firebase.firestore().collection('Dashboard').get()
    const groups = querySnapshot.docs.map((doc) => {
      return {...doc.data(), id:doc.id}
    })
   return {data: groups}
  }
  catch(error){
   return {isError: true}
  }
}

export const addGroup = async (group) => {
  try {
    const documentRef = await firebase.firestore().collection('Dashboard').add(group)
    const groupData = await fetchSingleGroup(documentRef.id)
    if(groupData.data){
    
      return {data: {...groupData.data, id:documentRef.id}}
    }else{
      return {isError: true}
    }
  }
  catch(error){
    return {isError: true}
  }
}

export const updateGroup = async (group) => {
  try{
    await firebase.firestore().collection('Dashboard').doc(group.id).update(group)
    return {data:true}
  }catch(error){
    return {isError: true}
  }
}

export const fetchSingleGroup = async (id) => {
  try{
    const docSnapshot = await firebase.firestore().collection('Dashboard').doc(id).get()
    return {data: docSnapshot.data()}
  }
  catch(error){
    return {isError: true}
  }
}

export const deleteGroup = async (id) => {
  try {
    await firebase.firestore().collection('Dashboard').doc(id).delete()
    return {data:id}
  } 
  catch(error){
    return {isError: true}
  }
}